import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { LegalFees } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetLegalFeesWireInstructionsVerificationRequest {
    engagementId: number;
    verified: boolean;
}

export const SetLegalFeesWireInstructionsVerification = createAsyncThunk(
    'flowOfFunds/setLegalFeesWireInstructionsVerification',
    async (
        params: SetLegalFeesWireInstructionsVerificationRequest,
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/legalFees/wireInstructions/verification`,
                {
                    verified: params.verified,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to update the verification status');
            }

            return response.data as LegalFees;
        } catch (error) {
            createNotification('Could not update the verification status.', 'error');
            throw error;
        }
    }
);
